export default {
  default: () => import("/app/.app/layouts/default.vue"),
  empty: () => import("/app/.app/layouts/empty.vue"),
  portal: () => import("/app/.app/layouts/portal.vue"),
  "portal-calendar": () => import("/app/.app/layouts/portalCalendar.vue"),
  testing: () => import("/app/.app/layouts/testing.vue"),
  transport: () => import("/app/.app/layouts/transport.vue"),
  collapse: () => import("/app/layers/tairo-layout-collapse/layouts/collapse.vue")
}